import { render, staticRenderFns } from "./PermissionPreset.vue?vue&type=template&id=92488f32"
import script from "./PermissionPreset.vue?vue&type=script&lang=js"
export * from "./PermissionPreset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports